// FILE: src/components/main/RequireAdmin.jsx
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NotFound404 from "../../pages/errors/NotFound404";
import { getRole } from "../../api/general/api";

function normIsAdmin(raw) {
  if (raw === true) return true;
  if (!raw) return false;
  if (typeof raw === "number") return raw === 1;
  if (typeof raw === "string") {
    const v = raw.trim().toLowerCase();
    return v === "1" || v === "true" || v === "yes" || v === "admin";
  }
  if (typeof raw === "object") {
    const u = raw;
    if (u.is_admin === true || u.isAdmin === true) return true;
    if (typeof u.role === "string" && ["admin", "owner", "superadmin"].includes(u.role)) return true;
    if (Array.isArray(u.roles) && u.roles.includes("admin")) return true;
    if (Array.isArray(u.scopes) && u.scopes.includes("admin")) return true;
    if (typeof u.is_admin === "number") return u.is_admin === 1;
    if (typeof u.isAdmin === "number") return u.isAdmin === 1;
    if (typeof u.is_admin === "string") {
      const v = u.is_admin.trim().toLowerCase();
      if (["1", "true", "yes", "admin"].includes(v)) return true;
    }
    if (typeof u.isAdmin === "string") {
      const v = u.isAdmin.trim().toLowerCase();
      if (["1", "true", "yes", "admin"].includes(v)) return true;
    }
  }
  return false;
}

const RequireAdmin = () => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await getRole();
        if (!mounted) return;
        setAllowed(normIsAdmin(data));
      } catch {
        if (!mounted) return;
        setAllowed(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/70 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-3">
          <div className="relative h-8 w-8">
            <div className="absolute inset-0 rounded-full border-2 border-white/15" />
            <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-violet-500 animate-spin" />
          </div>
          <div className="text-sm text-white/80">Проверяем права…</div>
        </div>
      </div>
    );
  }

  return allowed ? <Outlet /> : <NotFound404 />;
};

export default RequireAdmin;
